import { JobQuoteLineItem } from './helpers';

export const PLACEHOLDER_ITEMS: JobQuoteLineItem[] = [
  {
    type: 'kanda',
    title: 'Item 1',
    price: 100,
    description: 'Item description',
  },
  {
    type: 'kanda',
    title: 'Item 2',
    price: 100,
    description: 'Item description',
  },
  {
    type: 'kanda',
    title: 'Item 3',
    price: 100,
    description: 'Item description',
  },
];
